interface Props {
  size?: 'sm' | 'md' | 'lg'
}

const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' }

export function LoadingSpinner({ size = 'md' }: Props) {
  return (
    <div
      className={`${sizes[size]} border-2 border-primary/20 border-t-primary rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
    />
  )
}
